<div class="pheno-gwas-container">
  <div class="pheno-component">
    <div class="center-plots">
      <h3 style="margin-top: 15px">
        PheWAS - Phenome-Wide Association Studies based on the
        <span class="activator"
          ><a
            class="resource-biobank"
            href="https://pan.ukbb.broadinstitute.org/"
            target="_blank"
            >Pan-UK Biobank</a
          ></span
        >
      </h3>
      <div class="pheno-act">
        <h5 style="color: black" class="header-text-1">
          💡 Right-click on any row for details on the phenotype
        </h5>
        <button
          class="download-tsv"
          @click="downloadTSV"
          :disabled="loadingDownload"
        >
          {{ loadingDownload ? 'Preparing...' : 'Save Table Data' }}
        </button>
      </div>
      <br />
      <div id="table" class="plot-container-pheno"></div>
    </div>
    <div class="info-params">
      <div class="param"><b>S: </b> Selection coeificient</div>
      <div class="param"><b>β: </b> GWAS effect size</div>
      <button
        class="download-scatter"
        @click="downloadScatter"
        :disabled="loadingScatterDownload"
      >
        {{ loadingScatterDownload ? 'Preparing...' : 'Save Plot Data'
        }}
      </button>
    </div>
    <br><br><br><br><br>
    <div class="info-ld">
      <div class="ld-param">Linkage Disequilibrium (r<sup>2</sup>)</div>
    </div>
    <div class="center-charts">
      <div class="center-pheno">
        <div class="ld-0">0</div>
        <div class="ld-1">1</div>
        <div
          id="pehnoLoader"
          v-if="computation.gwas == 'PROCESS'"
          style="background-color: rgba(0, 0, 0, 0)"
        >
          <scale-loader
            :loading="gridLoading"
            :color="gridColor"
            :size="gridSize"
          ></scale-loader>
          <h5 style="margin-top: 10px">
            Loading Data... This should take only a few seconds.
          </h5>
        </div>
        <div
          class="plotSquarContainer"
          :style="{ 'filter': computation.gwas === 'PROCESS' ? 'blur(18px) contrast(80%)' : 'none', 'background-color': computation.gwas === 'PROCESS' ? 'rgba(0, 0, 150, 0.2)' : 'white',
              'opacity': computation.gwas === 'PROCESS' ? 0.3 : 1}"
        >
          <div id="glm-plot" style="width: 315px; height: 330px"></div>
        </div>
        <div
          class="plotSquarContainer"
          :style="{ 'filter': computation.gwas === 'PROCESS' ? 'blur(18px) contrast(80%)' : 'none', 'background-color': computation.gwas === 'PROCESS' ? 'rgba(0, 0, 150, 0.2)' : 'white',
              'opacity': computation.gwas === 'PROCESS' ? 0.3 : 1}"
        >
          <div id="gwas-plot" style="width: 315px; height: 330px"></div>
        </div>
        <div
          class="plotSquarContainer"
          :style="{ 'filter': computation.gwas === 'PROCESS' ? 'blur(18px) contrast(80%)' : 'none', 'background-color': computation.gwas === 'PROCESS' ? 'rgba(0, 0, 150, 0.2)' : 'white',
              'opacity': computation.gwas === 'PROCESS' ? 0.3 : 1}"
        >
          <div class="checkbox-container">
            <div class="vep-impact">Ensembl VEP Impact</div>
            <label
              ><input
                type="checkbox"
                value="MODIFIER"
                class="impact-checkbox"
                checked
              />
              MODIFIER</label
            >
            <label
              ><input
                type="checkbox"
                value="LOW"
                class="impact-checkbox"
                checked
              />
              LOW</label
            >
            <label
              ><input
                type="checkbox"
                value="MODERATE"
                class="impact-checkbox"
                checked
              />
              MODERATE</label
            >
            <label
              ><input
                type="checkbox"
                value="HIGH"
                class="impact-checkbox"
                checked
              />
              HIGH</label
            >
          </div>
            <span class="help-selection-gwas" @click="infoSelectionGwas()">
              <span style="font-size: 21px;" class="material-symbols-outlined">info</span>
            </span>
            <span class="help-gwas" @click="infoGwas()">
              <span style="font-size: 21px;" class="material-symbols-outlined">info</span>
            </span>
            <span class="help-selection" @click="infoSelection()">
              <span style="font-size: 21px;" class="material-symbols-outlined">info</span>
            </span>



            <span class="reset-gwas" @click="resetGwas()">
              <span style="font-size: 21px;" class="material-symbols-outlined">autorenew</span>
            </span>
            <span class="reset-gwas-selection" @click="resetSelectionGwas()">
              <span style="font-size: 21px;" class="material-symbols-outlined">autorenew</span>
            </span>
            <span class="reset-selection" @click="resetSelection()">
              <span style="font-size: 21px;" class="material-symbols-outlined">autorenew</span>
            </span>
          <div id="glm-gwas-plot" style="width: 315px; height: 330px"></div>
        </div>
      </div>
    </div>
  </div>
</div>
